import { useCallback, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { dealBuilderApi, InventoryEquipmentItem, InventoryFullListResponse } from '../api';

export const useEquipmentSearch = () => {
  const [results, setResults] = useState<InventoryEquipmentItem[]>([]);
  const [searchInventory, { loading }] = useLazyQuery<InventoryFullListResponse>(dealBuilderApi.getInventoryFullList);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = useCallback(
    (term: string) => {
      if (debounceRef.current) clearTimeout(debounceRef.current);

      const trimmed = term.trim();
      if (!trimmed) {
        setResults([]);
        return;
      }

      debounceRef.current = setTimeout(async () => {
        const { data } = await searchInventory({
          variables: { input: { search: trimmed.toLowerCase() } },
        });
        setResults(data?.result?.list ?? []);
      }, 300);
    },
    [searchInventory]
  );

  return { search, results, loading };
};
